import React, { useState } from "react";
import "./style.css";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

function ContactCard({ theme, return: onReturn }) {
  const [formData, setFormData] = useState({
    contactBody: "",
    contactEmail: "",
    contactName: ""
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleContactSubmit = (event) => {
    event.preventDefault();
    console.log(formData);
  };

  return (
    <div>
      <Card bg={theme} style={{ padding: "10px" }}>
        <Card.Header style={{ textAlign: "center" }}>
          <h2 className="contact-text" style={{ color: "white" }}>
            Contact Us
          </h2>
        </Card.Header>
        <Card.Body>
          <Card.Title>
            <h4 className="contact-text" style={{ color: "white" }}>
              Please submit questions, comments or inquiries below!
            </h4>
          </Card.Title>
          <Card.Text></Card.Text>
        </Card.Body>
        <ListGroup className="list-group-flush">
          <form>
            <ListGroup.Item>
              <label>Your Name</label>
              <input
                value={formData.contactName}
                onChange={handleInputChange}
                type="text"
                name="contactName"
                className="form-control"
              />
            </ListGroup.Item>
            <ListGroup.Item>
              <label>Your E-mail</label>
              <input
                value={formData.contactEmail}
                onChange={handleInputChange}
                type="email"
                name="contactEmail"
                className="form-control"
              />
            </ListGroup.Item>
            <ListGroup.Item>
              <label>Message:</label>
              <textarea
                value={formData.contactBody}
                onChange={handleInputChange}
                name="contactBody"
                className="form-control"
                rows="10"
                cols="60"
              />
            </ListGroup.Item>
            <ListGroup.Item>
              <button onClick={handleContactSubmit} className="btn btn-info">
                Send Message
              </button>
            </ListGroup.Item>
          </form>
        </ListGroup>
        <Card.Body>
          <button className="btn btn-light" onClick={onReturn} style={{ float: "right" }}>
            Return
          </button>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ContactCard;
